import { render, staticRenderFns } from "./AddBins.vue?vue&type=template&id=3bd3a327&"
import script from "./AddBins.vue?vue&type=script&lang=js&"
export * from "./AddBins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports